import { apiFetch } from '@/api/apiFetch';

export type RecordingResponseType = 'answer' | 'processing' | 'answer_and_processing' | null;

export interface Note {
  id: string;
  text: string;
  createdAt: string;
}

export const notesQueryKey = ['notes'] as const;

export interface CreateRecordingPayload {
  text: string;
  inputType: 'text' | 'voice';
  fileId?: string | null;
}

export interface CreateRecordingResponse {
  id: string;
  text: string;
  answer: string | null;
  notes: Note[];
  type: RecordingResponseType;
  createdAt: string;
}

export const createRecording = async (payload: CreateRecordingPayload): Promise<CreateRecordingResponse> => {
  const res = await apiFetch(`/recordings`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    const err = (await res.json().catch(() => ({}))) as { error?: string };
    throw new Error(err?.error ?? res.statusText);
  }

  return (await res.json()) as CreateRecordingResponse;
};
